import { ReactNode } from 'react';

export function ContentWrapperCell({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-col gap-2 py-2 justify-center">{children}</div>
  );
}
